/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { DatePicker, Flex, Select } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

import { isNotNull } from '@totem/utilities/common';

const { RangePicker } = DatePicker;

export type PickerType = 'date' | 'week' | 'month' | 'quarter' | 'year';

type Props = {
  startTime: dayjs.Dayjs;
  endTime: dayjs.Dayjs;
  defaultTimeFrame: PickerType;
  allowClear?: boolean;
  onChange: (start: dayjs.Dayjs, end: dayjs.Dayjs) => void;
};

const DateRangePickerExtended = ({
  defaultTimeFrame,
  startTime,
  endTime,
  onChange,
  allowClear,
}: Props) => {
  const [picketType, setPicketType] = useState<PickerType>(defaultTimeFrame);
  const [pickerStartDate, setPickerStartDate] =
    useState<dayjs.Dayjs>(startTime);
  const [pickerEndDate, setPickerEndDate] = useState<dayjs.Dayjs>(endTime);

  const handleRangeChange = (dates: dayjs.Dayjs[], dateStrings: string[]) => {
    if (dates === null) {
      setPickerStartDate(null);

      setPickerEndDate(null);

      onChange(null, null);
      return;
    }

    if (dates && dates.length === 2) {
      const [startDayjs, endDayjs] = dates;
      let startDate: dayjs.Dayjs;
      let endDate: dayjs.Dayjs;

      switch (picketType) {
        case 'date':
          startDate = startDayjs.startOf('day');

          endDate = endDayjs.endOf('day');
          break;
        case 'week':
          startDate = startDayjs.startOf('week');

          endDate = endDayjs.endOf('week');
          break;
        case 'month':
          startDate = startDayjs.startOf('month');

          endDate = endDayjs.endOf('month');
          break;
        case 'quarter':
          startDate = startDayjs.startOf('quarter');

          endDate = endDayjs.endOf('quarter');
          break;
        case 'year':
          startDate = startDayjs.startOf('year');

          endDate = endDayjs.endOf('year');
          break;
        default:
          // Fallback or default logic
          startDate = startDayjs;

          endDate = endDayjs;
      }

      setPickerStartDate(startDate);

      setPickerEndDate(endDate);

      onChange(startDate, endDate);
    }
  };

  return (
    <Flex justify={'flex-start'} align={'center'}>
      <div>
        <Select
          value={picketType}
          onChange={(value) => setPicketType(value)}
          style={{ width: 100 }}
          options={[
            { value: 'date' as 'date', label: 'Custom' },
            { value: 'week' as 'week', label: 'Week' },
            { value: 'month' as 'month', label: 'Month' },
            { value: 'quarter' as 'quarter', label: 'Quarter' },
            { value: 'year' as 'year', label: 'Year' },
          ]}
        />
      </div>
      <div style={{ marginLeft: 16 }}>
        <RangePicker
          allowClear={isNotNull(allowClear) ? allowClear : true}
          picker={picketType}
          onChange={handleRangeChange}
          value={[pickerStartDate, pickerEndDate]}
        />
      </div>
    </Flex>
  );
};

export default DateRangePickerExtended;
